import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["_useNativeButton"];
import { Component } from 'react';
import http from 'hub-http/clients/apiClient';
import emptyFunction from 'react-utils/emptyFunction';
import { Button } from 'foundations-components/transitional/components/Button';
import { AVATAR_SIZES, DEFAULT_PROPS } from '../Constants';
import defaultPortalId from '../lib/defaultPortalId';
import LookupRecord from '../Records/LookupRecord';
import { Avatar } from '../Avatar';
import UploaderModal from './UploaderModal';
import { UploaderOptionsList } from './UploaderOptionsList';
import { getAvatarResolver } from '../lib/AvatarResolverWithSource';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export class AvatarUploader extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isUploadModalOpen: false,
      uploadedAvatarUri: undefined
    };
    this.onUploadAvatarClick = () => {
      this.setState({
        isUploadModalOpen: true
      });
    };
    this.onClearAvatarClick = () => {
      const {
        onFail,
        lookup
      } = this.props;
      const {
        type,
        primaryIdentifier
      } = lookup;
      let apiURI;
      if (type === 'vid') {
        apiURI = `/avatars/v1/overrides/contacts/vid/${primaryIdentifier}`;
      } else {
        apiURI = `/avatars/v1/overrides/companies/companyId/${primaryIdentifier}`;
      }
      http.delete(apiURI).then(() => {
        getAvatarResolver().setAvatarURI(new LookupRecord(lookup), null);
      }).catch(error => {
        onFail(error);
      });
    };
    this.onUploadModalConfirm = imageUri => {
      const {
        lookup,
        size
      } = this.props;
      const sizePx = size !== 'responsive' ? AVATAR_SIZES[size] : AVATAR_SIZES.xl;
      if (typeof imageUri === 'string' && imageUri.length > 0) {
        getAvatarResolver().setAvatarURI(new LookupRecord(Object.assign({}, lookup, {
          dimensions: sizePx
        })), imageUri);
        this.props.onSuccess(imageUri, lookup);
      }
      this.setState({
        isUploadModalOpen: false
      });
    };
    this.onUploadModalReject = error => {
      this.setState({
        isUploadModalOpen: false
      });
      if (error) {
        this.props.onFail(error);
      }
    };
    this.renderButton = props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
        use: "transparent",
        padding: "0 !important",
        margin: "0 !important",
        children: /*#__PURE__*/_jsx(Avatar, Object.assign({
          isEditable: true
        }, this.props))
      }));
    };
  }
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UploaderOptionsList, {
        onUploadAvatarClick: this.onUploadAvatarClick,
        onClearAvatarClick: this.onClearAvatarClick,
        renderButton: this.renderButton
      }), this.state.isUploadModalOpen ? /*#__PURE__*/_jsx(UploaderModal, {
        lookup: this.props.lookup,
        portalId: this.props.portalId,
        onConfirm: this.onUploadModalConfirm,
        onReject: this.onUploadModalReject
      }) : null]
    });
  }
}
AvatarUploader.defaultProps = {
  onFail: emptyFunction,
  onSuccess: emptyFunction,
  portalId: defaultPortalId(),
  size: DEFAULT_PROPS.size
};